export const ALL_JOBSITES = 1;
